import {
  List,
  Datagrid,
  TextField,
  ResourceComponentProps,
} from "react-admin";

export const TranscriptList = (props: ResourceComponentProps) => (
  <List {...props} bulkActionButtons={false}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="createdAt" />
      <TextField source="status" />
      <TextField source="entity" />
      <TextField source="entityId" />
    </Datagrid>
  </List>
);
